var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMacProfiIcon3Mobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4H6.66667C5.2 4 4 5.2 4 6.66667V25.3333C4 26.8 5.2 28 6.66667 28H25.3333C26.8 28 28 26.8 28 25.3333V6.66667C28 5.2 26.8 4 25.3333 4ZM25.3333 25.3333H6.66667V6.66667H25.3333V25.3333Z",
    fill: "#02E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 10.2933H15V12.2933H8.33333V10.2933ZM17.3333 21H24V23H17.3333V21ZM17.3333 17.6667H24V19.6667H17.3333V17.6667ZM10.6667 24H12.6667V21.3333H15.3333V19.3333H12.6667V16.6667H10.6667V19.3333H8V21.3333H10.6667V24ZM18.7867 14.6L20.6667 12.72L22.5467 14.6L23.96 13.1867L22.08 11.2933L23.96 9.41333L22.5467 8L20.6667 9.88L18.7867 8L17.3733 9.41333L19.2533 11.2933L17.3733 13.1867L18.7867 14.6Z",
    fill: "#02E2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacProfiIcon3Mobile);
export default __webpack_public_path__ + "static/media/mac-profi-icon3-mobile.2df76d94724043ed5bdf8d7f978f8f62.svg";
export { ForwardRef as ReactComponent };